// mobile menu js 

$(".header__mobi-left-menu").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-left-text-close").toggleClass("active");
    $(".header__mobi-left-text-open").toggleClass("active");
    $(".header__mobi-menu").toggleClass('active');
    // $(".header__menu-drawer").toggleClass("active");
    $("body").toggleClass("mobile__menu-open");
})








// hero-modal start




document.addEventListener("DOMContentLoaded", function () {
    const videoCards = document.querySelectorAll(".hero__video");
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const modalSource = modalVideo.querySelector("source");
    const closeBtn = document.querySelector(".hero__modal-close");

    videoCards.forEach(card => {
        card.addEventListener("click", function () {
            const source = card.getAttribute("data-video");
            modalSource.setAttribute("src", source);
            modalVideo.load();

            modal.classList.add("active");
            document.body.classList.add("video-modal-open");

            modalVideo.play().catch((err) => {
                console.warn("Autoplay failed:", err);
            });
        });
    });

    function closeModal() {
        modal.classList.remove("active");
        modalVideo.pause();
        modalVideo.currentTime = 0; // optional: reset to start
        modalSource.setAttribute("src", "");
        document.body.classList.remove("video-modal-open");
    }

    closeBtn.addEventListener("click", closeModal);

    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    $(".overlay").on('click', function () {
        $("body").removeClass("video-modal-open");
        closeModal();
    });
});


// hero-modal end




// review-card start


if ($(Window).width() < 768) {
    $('.review-card__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}


$('.review-card__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.review-card__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});






$(".review-card__item-img").click(function () {
    var video = $(this).find("video").get(0);
    var icon_image = $(this).find(".review-card__video-play-icon");
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});
$(".review-card__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).parent().find("video").get(0);
    var icon_image = $(this);
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});



// review-card end


// comparision image slider js start here


$(document).ready(function () {
    const $comparison = $('.comparision__images');
    const $slider = $comparison.find('.slider');
    const $after = $comparison.find('.image-after');
    const $divider = $comparison.find('.divider-line');

    // Drag functionality
    $slider.on('mousedown touchstart', function (e) {
        e.preventDefault();

        $(document).on('mousemove touchmove', function (e) {
            const pageX = e.pageX || e.originalEvent.touches[0].pageX;
            const offsetX = $comparison.offset().left;
            const width = $comparison.width();
            const position = Math.min(Math.max(0, pageX - offsetX), width);

            // Move slider and clip image
            $slider.css('left', `${position}px`);
            $after.css('clip-path', `inset(0 ${width - position}px 0 0)`);

            // Move the divider line
            $divider.css('left', `${position}px`);
        });

        $(document).on('mouseup touchend', function () {
            $(document).off('mousemove touchmove mouseup touchend');
        });
    });
});




// results-modal start

document.addEventListener("DOMContentLoaded", function () {
    const videoCards = document.querySelectorAll(".results__video , .results__video-play-icon");
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const modalSource = modalVideo.querySelector("source");
    const closeBtn = document.querySelector(".results__modal-close");

    videoCards.forEach(card => {
        card.addEventListener("click", function () {
            const source = card.getAttribute("data-video");

            modalSource.setAttribute("src", source);
            modalVideo.load();

            modal.classList.add("active");
            document.body.classList.add("video-modal-open");

            // ✅ Autoplay after load
            modalVideo.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        });
    });

    function closeModal() {
        modal.classList.remove("active");
        modalVideo.pause();
        modalVideo.currentTime = 0; // Optional reset
        modalSource.setAttribute("src", "");
        document.body.classList.remove("video-modal-open");
    }

    closeBtn.addEventListener("click", closeModal);

    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });

    $(".overlay").on('click', function () {
        $("body").removeClass("video-modal-open");
        closeModal();
    });
});


// results-modal end








// treatments start


if ($(Window).width() < 768) {
    $('.treatments__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}



$('.treatments__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.treatments__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});









document.addEventListener("DOMContentLoaded", function () {
    const videoTriggers = document.querySelectorAll(".treatments__video-play-icon");
    const modal = document.getElementById("videoModal");
    const modalVideo = document.getElementById("modalVideo");
    const modalSource = modalVideo.querySelector("source");
    const closeBtn = document.querySelector(".treatments__modal-close");

    videoTriggers.forEach(trigger => {
        trigger.addEventListener("click", function () {
            const videoContainer = trigger.closest(".treatments__img");
            const videoSrc = videoContainer.getAttribute("data-video");

            modalSource.setAttribute("src", videoSrc);
            modalVideo.load();

            modal.classList.add("active");
            document.body.classList.add("video-modal-open");

            // ✅ Autoplay after load
            modalVideo.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        });
    });

    function closeModal() {
        modal.classList.remove("active");
        modalVideo.pause();
        modalVideo.currentTime = 0;
        modalSource.setAttribute("src", "");
        document.body.classList.remove("video-modal-open");
    }

    closeBtn.addEventListener("click", closeModal);

    window.addEventListener("click", function (e) {
        if (e.target === modal) {
            closeModal();
        }
    });
});



// treatments end





// --------------benefits start-------------


if ($(Window).width() < 768) {
    $('.benefits__items').slick({
        rows: 2,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}




$('.benefits__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.benefits__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




// --------------benefits end-------------




// ---------------product start-----------------



$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    asNavFor: '.product__small-items',
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, ]
});
$('.product__small-items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    infinite: true,
    responsive: [{
        breakpoint: 768,
        settings: {
            vertical: false,
            slidesToShow: 4,
            slidesToScroll: 1
        }
    }, ]
});


$('.product__small-items-left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__small-items-right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




// ---------------product end-----------------






// faq start



$(".faq__title , .product__dropdown-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__content , .product__dropdown-content").slideUp();
    } else {
        $(".faq__content , .product__dropdown-content").slideUp();
        $(".faq__title , .product__dropdown-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__content , .product__dropdown-content").slideDown();
    }
})




$(".product__purchase-title").on("click", function () {
    var hasActive = $(this).hasClass("active");

    if (!hasActive) {
        $(".product__purchase-title").removeClass("active")
        $(".product__purchase-content").slideUp()
        $(this).addClass("active");
        $(this).next(".product__purchase-content").slideDown();
    }
})


// faq end




// ---------------------footer start--------------------


if ($(Window).width() < 768) {
    $(".footer__center-item h3").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".footer__center-list").slideUp();
        } else {
            $(".footer__center-list").slideUp();
            $(".footer__center-item h3").removeClass("active");
            $(this).addClass("active");
            $(this).next(".footer__center-list").slideDown();
        }
    })
}





// ---------------------footer end--------------------



// popup start


function openImageModal($this) {
    var $src = $($this).siblings("img").attr("src");
    $(".popup").fadeIn();
    $(".popup__main-img img").attr("src", $src);
    $(".popup__close").fadeIn(); // 
}

$(".overlay").click(function () {
    $(".popup").fadeOut();
    $(".popup__close").fadeOut();
    $("body").removeClass('active-popup');
    $("body").removeClass('cart-open');

});

function closeImageModal() {
    $(".popup").fadeOut();
    $(".popup__close").fadeOut();
    $("body").removeClass('active-popup');
}



$(".product__big-item-zoom").on('click', function () {
    $("body").addClass('active-popup');
})


// popup end




// ---------------------cart start-----------------
$(".header__right-cart").on('click', function () {
    $("body").addClass('cart-open');
})
$(".cart__top-cross-img , .overlay-bg").on('click', function () {
    $("body").removeClass('cart-open');
})
// ---------------------cart end-----------------



document.addEventListener("DOMContentLoaded", function () {
    const stickyBtn = document.querySelector(".sticky-btn");
    const productInner = document.querySelector(".product__inner");

    let hasScrolled100px = false;
    let productInnerInView = false;
    const checkScroll = () => {
        if (window.scrollY > 100) {
            hasScrolled100px = true;
            updateVisibility();
        } else {
            stickyBtn.classList.remove("visible");
        }
    };

    const updateVisibility = () => {
        if (!hasScrolled100px) return;

        if (productInnerInView) {

            stickyBtn.classList.remove("visible");
        } else {

            stickyBtn.classList.add("visible");
        }
    };



   const observer = new IntersectionObserver(
  function (entries) {
    entries.forEach(entry => {
      if (entry.target.classList.contains("product__inner")) {
        productInnerInView = entry.intersectionRatio > 0.3; 
        updateVisibility();
      }
    });
  },
  {
    root: null,
    threshold: 0.3
  }
);


    if (productInner) {
        observer.observe(productInner);
    }

    // Track scroll position
    window.addEventListener('scroll', checkScroll);
});





$(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();
    const $body = $('body');

    if (currentScroll >= 35) {
        $body.addClass('header-sticky');
    } else {
        $body.removeClass('header-sticky');
    }
});